import { requestApi } from '@app/api';
import { withSubscription } from '@app/api/paths';
import PaymentItem from '@app/features/subscription/types/PaymentItem';
import AvailableFeature from '@app/store/transport-layer/subscription/AvailableFeatureItem';
import FeatureUsage from '@app/store/transport-layer/subscription/FeatureUsageItem';
import PlanItem from '@app/store/transport-layer/subscription/PlanItem';

export interface CreateCurrentPaymentEstimationResponse {
  amount: number;
  deductionAmount: number;
  deductionItems: Array<AvailableFeature | FeatureUsage | PlanItem>;
  finalAmount: number;
  prorationMonth: number | null;
  purchaseItems: Array<AvailableFeature | FeatureUsage | PlanItem>;
}

type CreateCurrentPaymentEstimationParam = PaymentItem[];

export function createCurrentPaymentEstimation(
  workspaceId: string,
  payload: CreateCurrentPaymentEstimationParam
): Promise<CreateCurrentPaymentEstimationResponse> {
  return requestApi<CreateCurrentPaymentEstimationResponse>({
    url: withSubscription(`/workspaces/${workspaceId}/subscription/payment/estimation`),
    method: 'POST',
    credentials: true,
    data: {
      items: payload.map((item) => {
        if (item.type === 'PLAN') {
          return { planId: item.planId, type: item.type };
        }
        return { ...item };
      }),
    },
  }).then((response) => response.data);
}
